import React, { PropsWithChildren } from 'react';

import { ToggleButtonGroup as MuiToggleButtonGroup } from '@mui/material';

import { AtomProps } from '@/uiKit/atoms/utils/AtomTypes.ts';

export type BaseToggleButtonGroupProps = PropsWithChildren<{}>;

export type ToggleButtonGroupProps = AtomProps<BaseToggleButtonGroupProps>;

export const ToggleButtonGroup: React.FC<ToggleButtonGroupProps> = ({
  children,
  ...props
}) => {
  return <MuiToggleButtonGroup {...props}>{children}</MuiToggleButtonGroup>;
};
